import { evaluateExpression as coreEvaluate } from '@examdojo/core/widget';
import type { Value } from '../geometrypad.model';
import type { PortRegistry } from './port-registry';

/**
 * Resolve a Value to a number.
 * - If the value is already a number, return it directly.
 * - If it's a string, evaluate it as an expression with port references.
 */
export function resolveValue(value: Value, registry: PortRegistry): number {
  if (typeof value === 'number') {
    return value;
  }
  return coreEvaluate(value, registry);
}

/**
 * Check if a Value contains port references (is reactive).
 */
export function isReactiveValue(value: Value): boolean {
  return typeof value === 'string';
}

/**
 * Check if any value in a record is reactive.
 */
export function hasReactiveValues(values: Record<string, Value> | undefined): boolean {
  if (!values) {
    return false;
  }
  return Object.values(values).some(isReactiveValue);
}

/**
 * Create a getter function for a value that resolves reactively.
 * For numeric values, returns a constant function.
 * For string expressions, returns a function that evaluates on each call.
 */
export function createValueGetter(value: Value, registry: PortRegistry): () => number {
  if (typeof value === 'number') {
    return () => value;
  }
  return () => coreEvaluate(value, registry);
}
